import React, { useEffect, useState } from 'react';
import HamQuest from './api/HamQuestGiver';
import Row from './layout/Row';
import LoadingEllipsis from './forms/LoadingEllipsis';
import ModalFactory from './Modal';

export const loadingRadioState = [{ label: <Row>Loading Options<LoadingEllipsis /></Row>, value: '' }]
export const loadingSelectState = [{ label: 'Loading Options', value: '' }]

const GetState = (url, { callback = null, loading = null, finalCall = null } = {}) => {
    const [state, setState] = useState(null);

    const fetchData = (urlOverride) => (
        HamQuest.get(urlOverride ?? url)
            .then(res => {
                if (callback) {
                    res instanceof Array ?
                        res.forEach(e => callback(e))
                        : callback(res)
                }
                if (finalCall) {
                    res = finalCall(res)
                }
                setState(res)
                return res;
            })
            .catch(ex => {
                ModalFactory.catch(ex)
                setState(ex)
            })
    )

    useEffect(() => {
        if (!url) return;
        fetchData()
    }, [])

    return [
        state ?? loading,
        fetchData,
        setState,
    ]
}

export default GetState;
